/**
 * @(#)2019/8/06.
 * Modal 模态框-用于弹出各种处理
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import "./index.less";
import React from "react";
import { Modal } from "antd";
import defaultProps from "./param";
import { get } from "../../../utils/index";
import { YxComponent, Connection } from "../../YxComponent";

@Connection(defaultProps)
export default class extends YxComponent {
  constructor(...args) {
    super(...args);
    this.className = "yx_modal";
  }

  render() {
    const propsClassName = get(this.props, "className", "");
    const className = [this.className, propsClassName];
    return <Modal {...this.props} className={className.join(" ")}></Modal>;
  }
}



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxModal/Modal/index.js